import { render, staticRenderFns } from "./DateRangeV2.vue?vue&type=template&id=13da36ee&"
import script from "./DateRangeV2.vue?vue&type=script&lang=js&"
export * from "./DateRangeV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports